import { ChangeDetectionStrategy, Component, booleanAttribute, input } from '@angular/core';

export type VhCardVariant = 'elevated' | 'outlined' | 'flat';

/**
 * Generic container card. Projects named slots so specialized cards
 * (product, vendor, category) can compose it without re-inventing
 * padding, radius, and hover behaviour.
 *
 * Usage:
 *   <vh-card variant="elevated" [interactive]="true">
 *     <div vh-card-media>...</div>
 *     <div vh-card-header>...</div>
 *     body content
 *     <div vh-card-footer>...</div>
 *   </vh-card>
 */
@Component({
  selector: 'vh-card',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="vh-card__media"><ng-content select="[vh-card-media]" /></div>
    <div class="vh-card__header"><ng-content select="[vh-card-header]" /></div>
    <div class="vh-card__body"><ng-content /></div>
    <div class="vh-card__footer"><ng-content select="[vh-card-footer]" /></div>
  `,
  styleUrl: './card.component.scss',
  host: {
    '[class.vh-card]': 'true',
    '[class.vh-card--elevated]': 'variant() === "elevated"',
    '[class.vh-card--outlined]': 'variant() === "outlined"',
    '[class.vh-card--flat]': 'variant() === "flat"',
    '[class.vh-card--interactive]': 'interactive()',
  },
})
export class VhCardComponent {
  readonly variant = input<VhCardVariant>('elevated');
  readonly interactive = input(false, { transform: booleanAttribute });
}
